import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React from 'react';
import { pick } from "../../utils";
import withGGEditorContext from "../../common/context/GGEditorContext/withGGEditorContext";
import Item from "./Item";

var ItemPanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ItemPanel, _React$Component);

  function ItemPanel(props) {
    var _this;

    _classCallCheck(this, ItemPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ItemPanel).call(this, props));
    _this.page = null;

    _this.handleMouseUp = function () {
      _this.page.cancelAdd();
    };

    _this.bindEvent();

    return _this;
  }

  _createClass(ItemPanel, [{
    key: "bindEvent",
    value: function bindEvent() {
      var _this2 = this;

      var onAfterAddPage = this.props.onAfterAddPage;
      onAfterAddPage(function (_ref) {
        var page = _ref.page;
        _this2.page = page;
        document.addEventListener('mouseup', _this2.handleMouseUp);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement("div", _extends({
        id: this.containerId
      }, pick(this.props, ['style', 'className'])), children);
    }
  }]);

  return ItemPanel;
}(React.Component);

export { Item };
export default withGGEditorContext(ItemPanel);